module.exports = __webpack_public_path__ + "img/KinokoTable53.05b66888.jpg";